import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "fwdRef", "tagName"];
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { buildVersionedClass } from '@op/opds.opux-utilities';
/**
 * A component which hides content from sighted users but is still accessible with screen readers.
 *
 * Additional props (including `ref`) will be forwarded to the wrapping HTML element.
 */
export const ScreenReaderOnly = _ref => {
  let {
      children,
      className,
      fwdRef,
      tagName: Tag = 'span'
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const SROClasses = classNames(buildVersionedClass('ds-screen-reader-only'), className);
  return (
    /*#__PURE__*/
    // Polymorphic "tagName" makes Typescript crash due to:
    // "Expression produces a union type that is too complex to represent."
    // A more robust solution must be implemented and used throughout OPUX.
    // @ts-expect-error -- Typing fwdRef as HTMLElement will not work with any tag therefore we just ignore the error
    React.createElement(Tag, _extends({
      className: SROClasses,
      ref: fwdRef
    }, otherProps), children)
  );
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(ScreenReaderOnly, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'ScreenReaderOnly';
export default Fwd;